import React, { type FC, type PropsWithChildren, type ReactNode } from 'react';
import MuiModal from '@mui/material/Modal';
import classnames from 'classnames';
import { X } from 'react-bootstrap-icons';

import styles from 'theme/components/wise/WiseModal/WiseModal.module.scss';

export type WiseModalProps = PropsWithChildren<{
  open: boolean;
  title?: ReactNode;
  onClose?: () => void;
  maxWidth?: number | string;
  className?: string;
}>;

const WiseModal: FC<WiseModalProps> = ({
  open,
  title,
  onClose,
  maxWidth = 720,
  className,
  children
}) => {
  return (
    <MuiModal
      open={open}
      onClose={onClose}
      className={classnames(styles.modalRoot, 'StylePath-Components-Wise-WiseModal')}>
      <div className={styles.backdropCenter}>
        <div
          className={classnames(styles.panel, className)}
          style={{ maxWidth }}
          role="dialog"
          aria-modal="true"
          aria-label={typeof title === 'string' ? title : undefined}
          onClick={(e) => e.stopPropagation()}>
          {(title || onClose) && (
            <div className={styles.header}>
              <div className={styles.title}>{title}</div>
              {onClose && (
                <button
                  type="button"
                  className={styles.closeButton}
                  aria-label="Zamknij"
                  onClick={onClose}>
                  <X aria-hidden />
                </button>
              )}
            </div>
          )}

          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </MuiModal>
  );
};

export default WiseModal;

